import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as authAction from "../Store/_redux/AuthStore/authActions";
import useEffect from "react";

function PasswordOperationsPage({ onCancel, onSuccess }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //useEffect(() => { dispatch(authAction.getUsers()); }, [dispatch])

  // Kullanıcı listesini nereden alıyorsunuz? Örneğin store'dan:
  const users = useSelector((state) => state.auth.users); // Varsayalım ki var

  const [selectedUser, setSelectedUser] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUser) {
      toast.error("Lütfen bir kullanıcı seçin");
      return;
    }

    setLoading(true);
    try {
      const result = await dispatch(authAction.resetPassword({
        userId: selectedUser,
        newPassword: newPassword || undefined, // Boşsa backend varsayılan şifre atayabilir
      }));
      
      if (result && result.success) {
        toast.success(result.message || "Şifre başarıyla güncellendi");
        if (onSuccess) {
          onSuccess();
        } else {
          navigate("/dashboard"); // İşlem sonrası yönlendir
        }
      } else {
        toast.error(result?.message || "Bir hata oluştu");
      }
    } catch (error) {
      toast.error("Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={onCancel ? "w-full" : "max-w-2xl mx-auto p-6"}>
      <h1 className="text-2xl font-semibold mb-6">Şifre İşlemleri</h1>
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Kullanıcı</label>
          <select
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            className="w-full border rounded px-3 py-2"
            required
          >
            <option value="">Kullanıcı seçiniz...</option>
            {users?.map((user) => (
              <option key={user._id} value={user._id}>
                {user.name} {user.surname} - {user.tc}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Yeni Şifre (opsiyonel)
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Boş bırakılırsa: Pavza2022*"
            className="w-full border rounded px-3 py-2"
          />
          <p className="text-xs text-gray-500 mt-1">
            Boş bırakılırsa varsayılan şifre atanır: Pavza2022*
          </p>
        </div>

        <div className="flex gap-2">
          <button
            type="submit"
            disabled={loading}
            className="flex-1 bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:bg-blue-300"
          >
            {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
          </button>
          <button
            type="button"
            onClick={onCancel ? onCancel : () => navigate(-1)}
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50"
          >
            İptal
          </button>
        </div>
      </form>
    </div>
  );
}

export default PasswordOperationsPage;